(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NewsListController', NewsListController);

    NewsListController.$inject = ['NewsService', '$state', '$sce', '$translate', '$q'];

    function NewsListController(NewsService, $state, $sce, $translate, $q) {
        var vm = this;

        vm.items = [];

        vm.trustedHtml = trustedHtml;
        vm.add = add;
        vm.remove = remove;

        loadData();

        function loadData() {
            NewsService.getList().then(function (response) {
                vm.items = response.data.content;
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }

        function trustedHtml(plainText) {
            return $sce.trustAsHtml(plainText);
        }

        function add() {
            $state.go('news_new');
        }

        function remove(id) {
            $translate('news.removeWarning').then(function (newsrRemoveWarningMessage) {
                if (confirm(newsrRemoveWarningMessage)) {
                    NewsService.remove(id);
                    vm.items = vm.items.filter(function (item) {
                        return item.id !== id
                    });
                }
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }
    }
})();
